var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p"),
      _c("h3", [
        _vm._v(
          "\n    Brugerbetingelser, Privatlivspolitik samt erklæring om databeskyttelse\n    ved brug af Zietwing.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [_c("strong", [_vm._v("2. januar 2023")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n    Disse vilkår for Bruger ("Aftale") er en juridisk kontrakt mellem Zietwing (CVR-nr. 16905844), Adresse: Egå Havvej 21, 8250 Egå, Danmark og Dig ("Bruger"). Omkring benyttelse af Zietwing produkt (”Zietwing”)\n  '
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("Fremadrettet:")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" Dig som bruger: Bruger/kunde\n    "),
        _c("br"),
        _vm._v(" Zietwing: Zietwing\n  ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    Zietwing kan kontaktes via e-mail på "),
        _c("a", { attrs: { href: "mailto:info@zietwing.com" } }, [
          _vm._v("info@zietwing.com")
        ]),
        _vm._v(".\n  ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    For at sikre dine betalingskortinformationer, benytter Zietwing en betalingsgateway som er godkendt af PCI Security Council Standard, med den højest tilgængelige certificering PCI DSS level 1. Dette sikrer højest mulig beskyttelse af kortinformationer.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Du skal gennemgå hele denne Aftale, før Du beslutter, om Du vil acceptere den og fortsætte tilmeldingsprocessen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Denne Aftale regulerer Din adgang til- og brug af Zietwing som betalingsplatform. Tjenesterne, der er beskrevet nedenfor, leveres af Zietwing.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    Hvis Du accepterer Aftalen, erklærer Du følgende:\n  ")
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("\n      Du er minimum 18 år, og\n    ")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Du er i stand til at indgå en juridisk bindende aftale.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Før Du fortsætter med registreringen skal du accepterer denne aftale, hvilket gøres ved at Du markerer ”accepter betingelser”. Aftalen træder i kraft på datoen for Din accept.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("1. Definerede termer")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    Følgende definerede ord fremgår af Aftalen:\n  ")
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Konto"')]),
        _vm._v(
          " er dit administrationslogin, hvor du kan registrere, se, ændre betalingskort informationer. Du kan ligeledes se, finde kommende samt tidligere transaktioner, som Zietwing platformen administrerer for Dig.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Aftale"')]),
        _vm._v(" er disse Servicevilkår for dig som bruger.\n  ")
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Indhold"')]),
        _vm._v(
          " er råd, meninger, tilbud, forslag, opgørelser, data eller andre oplysninger, der vises eller distribueres, købes eller betales via Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Kunde"')]),
        _vm._v(
          " er en person eller enhed, der er registreret i Platformen som Bruger eller Forhandler.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Tvister"')]),
        _vm._v(
          " er uenigheder, retssager, aftaler og/eller andre sådanne tvister mellem Kunder eller andre tredjeparter, der opstår som følge af brugen af Platformen, og som ikke vedrører tvister i forbindelse med Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Betalingsmetode"')]),
        _vm._v(
          " er kreditkort, betalingskort, Konto til Betaling via mobilregning eller andre betalingsmidler, som Du registrerer til brug sammen med Platformen, og som vil blive anvendt af Zietwing til at betale produkter/ydelser som du har købt ved en af de valgte forhandler som bruger Zietwing som betalingsløsning.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Betalingstransaktion"')]),
        _vm._v(
          " er den transaktion, hvorved Zietwing indleder overførsel af en Købesum fra Din Betalingsmetode til en Zietwing forhandler, via Zietwing forhandlers indløsningsaftale.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Zietwing.com"')]),
        _vm._v(
          " er et website for Zietwing eller dets hovedselskab eller Tilknyttede virksomheder, datterselskaber.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Loginoplysninger"')]),
        _vm._v(
          " er brugernavnet og adgangskoden, som Zietwing udsteder til Dig, så Du kan få adgang til Din Konto.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Betalingsordre"')]),
        _vm._v(
          " er den besked, som giver Zietwing platformen mulighed for at udføre en betalingstransaktion, der er godkendt af dig, og som også fungerer som din godkendelse til at indlede købet fra Zietwing forhandleren.\n    "
        ),
        _c("br"),
        _vm._v(" Samme gældende for en refusionstransaktion.\n  ")
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Produkt"')]),
        _vm._v(
          " er enhver digital eller fysisk vare eller tjeneste, Du kan købe fra en forhandler ved hjælp af Zietwing Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Købesum"')]),
        _vm._v(
          " er et beløb svarende til prisen på et Produkt, herunder eventuelle tilknyttede gebyrer, skatter eller forsendelsesomkostninger, som er relevante.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Forhandler"')]),
        _vm._v(
          " er en enhed, som bruger Platformen til at udbyde Produkter eller serviceydelser og modtage Købesummer fra betalingstransaktioner.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Platformen"')]),
        _vm._v(" er den betalingstjeneste, som leveres af Zietwing.\n  ")
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Tjenester"')]),
        _vm._v(" er alle tjenester, som leveres af Zietwing iht. Aftalen.\n  ")
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Tvister angående Platformen"')]),
        _vm._v(
          " er uenigheder, klager, retstvister, aftaler og/eller andre lignende tvister mellem Zietwing og Kunder/brugere, der udelukkende opstår som følge af påstande om, at Zietwing ikke overholder sine forpligtelser i henhold til denne Aftale eller gældende lovgivning samt fejl i forbindelse med leveringen af Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Datterselskaber og Tilknyttede virksomheder"')]),
        _vm._v(
          " er datterselskaber og tilknyttede juridiske enheder under Zietwing rundt om i hele verden.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Du"')]),
        _vm._v(" , "),
        _c("strong", [_vm._v('"Din"')]),
        _vm._v(" og "),
        _c("strong", [_vm._v('"Bruger"')]),
        _vm._v(
          " er en person, der ansøger om eller tilmelder sig brug, eller som bruger Platformen for at foretage en betalingstransaktion til køb af et Produkt hos en Zietwing forhandler.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v('"Din e-mailadresse"')]),
        _vm._v(" er den e-mailadresse, som Du angav under tilmeldingen.\n  ")
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("2. Dit forhold til Zietwing")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    2.1 Din brug af Platformen er underlagt Aftalen.\n  ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    2.2 Ved køb af produkter/tjenester bruger Zietwing din valgte betalingsmetode, til at foretage betalinger til Zietwing forhandlere.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    2.3 Du accepterer med denne aftale at Zietwing gemmer din betalingsmetode/betalingsinformationer og tilhørende, til fremtidige betalinger ved Zietwing forhandlere.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("3. Accept af Aftalen")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    3.1 Du skal acceptere Aftalen, før Du kan bruge tjenesterne, som er underlagt denne Aftale. Du kan ikke bruge tjenesterne, hvis Du ikke accepterer Aftalen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    3.2 Aftalen udgør en juridisk bindende aftale mellem Dig og Zietwing i forhold til din brug af tjenesterne, og det er vigtigt, at Du tager dig tid til at læse den grundigt. Ved at acceptere Aftalen accepterer Du at bruge tjenesterne i overensstemmelse med kravene i Aftalen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    3.3 Du kan acceptere denne Aftale ved at:\n  ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Klikke på Acceptér under oprettelse, hvis denne mulighed er til rådighed for dig i Zietwings brugergrænseflade, eller\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Ved at bruge tjenesterne. I dette tilfælde forstår og accepterer Du, at Zietwing behandler din brug af tjenesterne som accept af Aftalen fra dette tidspunkt og fremefter.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    3.4 Du kan ikke bruge tjenesterne eller acceptere Aftalen, hvis:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Du ikke er myndig til at indgå en bindende kontrakt med Zietwing og betjene Betalingsmetoden, som Du registrerer til brug med tjenesterne, eller\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Du er en person, som er afskåret fra at modtage tjenesterne i henhold til lovgivningen i Danmark eller andre lande, herunder det land, hvor Du er bosiddende, eller hvorfra Du bruger tjenesterne.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("4. Levering af Aftalen og sprog")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    4.1 I dit administrationslogin er at finde en kopi af denne Aftale i et udskriftsvenligt format. En kopi af Aftalen, som den ændres fra tid til anden, vil altid være tilgængelig på administrationslogin.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    4.2 Efter tilmelding kan Du anmode om at modtage denne Aftale, og der vil blive sendt et link til Aftalen til Din e-mailadresse.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    4.3 Aftalen er på dansk eller oversat til et andet sprog.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    4.4 Såfremt Zietwing har leveret en oversat version af den danske Aftale til Dig, accepterer Du, at oversættelsen udelukkende har til formål at fungere som en hjælp til Dig, og at den oversatte version af denne Aftale er bestemmende for Dit forhold til Zietwing på samme vilkår som den ikke oversatte version.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    4.5 Hvis der er nogen uoverensstemmelse mellem den dansksprogede version og en oversættelse, har den dansksprogede version forrang.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("5. Tilmelding til Platformen")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    5.1 Du skal angive alle nødvendige oplysninger på registreringssiderne til Zietwing for at kunne bruge tjenesterne.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    5.2 Du skal registrere en gyldig Betalingsmetode, der vil blive brugt til at købe via Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    5.3 Betalingsmetoden skal være tilknyttet en faktureringsadresse i et land, hvor Platformen er tilgængelig.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    5.4 Du skal angive aktuelle, fuldstændige og præcise oplysninger og sørge for, at de er aktuelle og præcise under din brug af tjenesterne. Zietwing kan kræve, at Du giver yderligere oplysninger for fortsat at kunne bruge tjenesterne, eller at Du hjælper Zietwing med at afgøre, om Du fortsat skal have tilladelse til at bruge tjenesterne. Du accepterer at give de oplysninger, som Zietwing kan kræve i denne henseende, herunder de nødvendige oplysninger for at validere din identitet eller bekræfte ægtheden af ​​enhver Betalingsmetode, som du registrerer til brug med Zietwing.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("6. Zietwings levering af Platformen")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    6.1 I nogle tilfælde vil Datterselskaber og tilknyttede virksomheder levere hele eller en del af Platformen til Dig på vegne af Zietwing. Du anerkender og accepterer, at Datterselskaber og tilknyttede virksomheder er berettigede til at levere Platformen til Dig.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    6.2 Zietwing arbejder hele tiden på at give brugerne den bedst mulige oplevelse. Du anerkender og accepterer, at Zietwing kan levere en ny tjeneste fra tid til anden uden forudgående varsel til Dig. Er den nye tjeneste i en form hvor der kræves en ny aftale, sender vi dig en revideret Aftale som følge af indførelsen af ​​en ny tjeneste via e-mail. Du kan acceptere den reviderede Aftale, som angivet i punkt 3.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    6.3 Du anerkender og accepterer, at Zietwing kan stoppe leveringen af tjenester til Dig, som fastsat i aftalen. Du kan ligeledes til enhver tid holde op med at bruge tjenesterne. Du behøver ikke at informere Zietwing, når du holder op med at bruge tjenesterne, men det er et krav at du selv opsiger dine betalinger og sletter din konto i dit Zietwing administrationsmodul.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    6.4 Du anerkender og accepterer, at Zietwing kan oprette generelle procedurer og begrænsninger i forbindelse med brugen af ​​tjenesterne uden forudgående varsel til Dig, herunder enkelte eller samlede transaktionsbegrænsninger på værdi af eller antallet af betalingstransaktioner i løbet af hvilket som helst angivet tidsrum.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    6.5 Zietwing kan afslå at udføre en betalingstransaktion, Betalingsordre eller anden brug af tjenesterne, hvis Zietwing har rimelig grund til at mistænke svig, overtrædelse af den gældende Aftale af Dig eller Forhandler, eller en overtrædelse af loven. Transaktioner kan også blive forsinkede på grund af Zietwings overholdelse af sine forpligtelser i henhold til gældende lovgivning om hvidvaskning af penge, bl.a. hvis Zietwing har mistanke om, at transaktionen omfatter svig. I tilfælde af at Zietwing nægter at udføre en betalingstransaktion eller Betalingsordre, vil Du blive underrettet herom, medmindre det er ulovligt for Zietwing at gøre det, eller medmindre det ville kompromittere rimelige sikkerhedsforanstaltninger.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    6.6 Du anerkender og accepterer, at hvis Zietwing deaktiverer adgang til Din Konto ved at stoppe brugen af Dine loginoplysninger, kan Du blive forhindret i at få adgang til Platformen, samt kontooplysninger eller filer eller andet indhold, som er på Din Konto.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("7. Din brug af Platformen")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    7.1 Du accepterer kun at bruge tjenesterne som tilladt ifølge:\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", [_c("li", [_vm._v("\n      Denne Aftale\n    ")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Politikker og begrænsninger for de tjenester, som offentliggøres og opdateres af Zietwing og dets tilknyttede virksomheder fra tid til anden, og\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Enhver gældende lov, regulering eller generelt accepterede fremgangsmåder eller retningslinjer i de relevante jurisdiktioner (herunder enhver lov, som vedrører eksport af data eller software til og fra Danmark eller andre relevante lande).\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Med forbehold for ovenstående accepterer og anerkender Du, at indberetning og betaling af eventuelle gældende skatter som følge af din brug af tjenesterne er Dit ansvar.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Du accepterer hermed at overholde alle gældende skatteregler, herunder indberetning og betaling af eventuelle skatter, der opstår i forbindelse med betalingstransaktioner.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Du accepterer ikke at få adgang til (eller forsøge at få adgang til) nogen del af tjenesterne på nogen anden måde end via den grænseflade, der leveres af Zietwing, medmindre Du har fået udtrykkelig tilladelse til at gøre dette i en separat aftale med Zietwing. Du anerkender, at denne begrænsning gælder for brug af tjenesterne ved hjælp af enhver form for automatiske midler.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Du accepterer, at du ikke vil tage del i aktiviteter, der forstyrrer eller afbryder tjenesterne (eller de servere og netværk, som er forbundet med tjenesterne).\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Medmindre Du har fået udtrykkelig tilladelse til det i en separat aftale med Zietwing, accepterer Du, at Du ikke vil reproducere, duplikere, kopiere, sælge, forhandle eller videresælge tjenesterne til noget formål.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Du accepterer, at Du er eneansvarlig for (og at Zietwing ikke har noget ansvar for Dig eller nogen tredjepart) enhver misligholdelse af Dine forpligtelser i henhold til denne Aftale og for følgerne (herunder ethvert tab eller enhver skade, som Zietwing måtte påføres) på grund af en sådan misligholdelse.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("8. Dine Loginoplysninger og kontosikkerhed")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    8.1 Du accepterer kun at bruge de Loginoplysninger, der er tilknyttet Din Konto, i overensstemmelse med de vilkår og betingelser, der er fastsat i denne Aftale om deres anvendelse.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    8.2 Du accepterer og forstår, at Du er ansvarlig for at opretholde fortroligheden af de Loginoplysninger, der er tilknyttet Din Konto, og for at tage alle rimelige forholdsregler for at holde disse oplysninger fortrolige.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    8.3 Hvis Du bruger Platformen i forretningssammenhæng, accepterer du, at alle funktionærer, medarbejdere, agenter, repræsentanter og andre, der har adgang til Dine Loginoplysninger, har gyldig tilladelse hertil, og har bemyndigelse til juridisk at binde den pågældende virksomhed, partnerskab eller anden juridisk enhed.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    8.4 Dit ansvar for brugen af Platformen er anført i paragraf 17 nedenfor.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    8.5 Du accepterer at underrette Zietwing uden unødig forsinkelse ved hjælp af sende e-mail til info@zietwing.com, hvis Du bliver opmærksom på tab, tyveri, misbrug eller uautoriseret brug af Dine Loginoplysninger. Du accepterer også at underrette Zietwing uden unødig forsinkelse og på samme måde om andre brud på sikkerheden vedrørende Platformen, som Du har kendskab til.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    8.6 Hvis Du mener, at Din Konto er blevet åbnet eller brugt på en uautoriseret måde, skal du ændre dine login informationer øjeblikkeligt efter du er opmærksom på dette.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    8.7 Du accepterer at underrette Zietwing ved at sende e-mail til info@zietwing.com uden unødig forsinkelse og ikke senere end 3 måneder efter debiteringsdatoen (hvilket vil være den samme dato, midlerne er trukket fra Din Betalingsmetode), efter at have konstateret en uautoriseret eller fejlbehandlet transaktion.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    8.8 Zietwing kan suspendere brugen af Dine Loginoplysninger eller Din Konto, hvis de mistænker, at sikkerheden kan være blevet kompromitteret, eller hvis uautoriseret- eller svigagtig brug har fundet sted.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    8.9 Zietwing informerer Dig på forhånd, eller hvis dette ikke er muligt, umiddelbart efter at brugen af Dine Loginoplysninger eller Din Konto er blevet suspenderet, og vil om muligt angive årsagen til suspenderingen, medmindre videregivelsen af sådanne oplysninger vil kompromittere rimelige sikkerhedsforanstaltninger eller på anden måde være ulovlig. Zietwing kan vælge at genaktivere dine Loginoplysninger eller Konto, eller give Dig nye Loginoplysninger eller ny Konto, hurtigst muligt, efter at årsagen til suspenderingen er behandlet.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("9. Beskyttelse af Dine personlige oplysninger")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    9.1 Du kan få flere oplysninger om Zietwings metoder til databeskyttelse ved at læse Zietwing's privatlivspolitik Paragraf 24. Denne politik forklarer, hvordan Zietwing behandler og beskytter Dine personlige oplysninger, når du bruger tjenesterne.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    9.2 Du accepterer brugen af Dine data i overensstemmelse med Zietwings privatlivspolitik.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    9.3 Bekræftelse af Brugeridentitet: Krav til forhindring af hvidvaskning af penge.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Bruger anerkender, at Zietwing udbyder og fortsat vil udbyde tjenesterne til Bruger, forudsat at Bruger består de regelmæssige kontroller, herunder identitetskontrol foretaget af Zietwing, og overholder kravene fra Zietwing, kortsammenslutningen og lovgivningen om forhindring af hvidvaskning af penge. Identitetskontrol kan omfatte kreditvurderinger, kontroller vedrørende hvidvaskning af penge i henhold til relevant lovgivning, kontroller, som kræves af kortsammenslutninger, samt kontroller i henhold til relevante lovmæssige krav. Bruger skal ved anmodning hjælpe Zietwing med at foretage sådanne kontroller og vurdere overholdelsen af krav om forhindring af hvidvaskning af penge, for eksempel ved at angive yderligere oplysninger om bekræftelse af registrering eller identitet, når Zietwing kræver dette.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Bruger indvilger i, at Zietwing deler med- og indhenter oplysninger fra tredjeparter, både i og uden for det europæiske økonomiske samarbejdsområde, og i det omfang det er tilladt ved lov, oplysninger, der vedrører Bruger, herunder personlige oplysninger som defineret i henhold til gældende lovgivning om databeskyttelse, med det formål, at Zietwing anvender den gældende rettidige omhu og identitetskontrol, og Bruger er enig i, at sådanne tredjeparter kan få de oplysninger, der deles på denne måde.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Manglende overholdelse af betingelserne i denne paragraf 9.3, herunder at Bruger leverer de oplysninger, som Zietwing anmoder om, med henblik på at bekræfte Din identitet eller vurdere Din overholdelse af kravene til forhindring af hvidvaskning, kan medføre øjeblikkelig suspendering af Brugers brug af tjenesterne samt rophævelse af denne Aftale.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("10. Betalingsmetode")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    10.1 Du accepterer, at oplysninger om Din Betalingsmetode vil blive brugt af Ziewing til at:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Debitere eller kreditere Dig for Købesummen, herunder alle relaterede gebyrer, skatter eller forsendelsesomkostninger, som er anvendelige ved køb gennem en Zietwing forhandler hvor du har accepteret købet samt forhandlerens betingelser for dette køb,\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Behandle alle betalinger, der er nødvendige for at opkræve betaling for andre gebyrer eller afgifter, som er opstået som følge af Din brug af Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Videregive mulighed for tredjepart/Zietwing forhandler, på din anmodning og accept, kan opkræve betaling for varer eller tjenester, som denne leverer til dig. Dette er en Ureguleret Tjeneste/ydelse/køb for Zietwing, hvor Zietwing udelukkende foretager betalingen. I disse tilfælde har Zietwing ingen yderligere involvering i Din transaktion med tredjeparten, efter Betalingstransaktionen er foretaget. Du bør kontakte tredjeparten eller din Betalingsmetodeudbyder (f.eks. bank - kredit- eller betalingskortudbyder) direkte med eventuelle problemer med sådanne tredjepartstransaktioner, herunder refusioner og tvister.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    10.2 Du giver Zietwing bemyndigelse til at bekræfte, at der er tilstrækkelig dækning på Din Betalingsmetode hos det udstedende pengeinstitut, Mobilselskab for så vidt andre, herunder, men ikke begrænset til, at sende en anmodning om godkendelse af betaling og/eller en lav kreditering og/eller debitering af Betalingsmetoden i overensstemmelse med de relevante kortsammenslutningers regler.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    10.3 Du tillader, at Zietwing indhenter en kreditvurdering og/eller på anden måde laver forespørgsler om kredit- eller andre baggrundsoplysninger fra tid til anden, som Zietwing måtte finde passende for at vurdere Din tilmelding til eller fortsatte brug af Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [
        _vm._v(
          "\n    11. Behandling af betaling med kort, bank til bank, Betaling via\n    mobilregning, køb af abonnementer/tilbagevendende transaktioner\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    11.1 Zietwing accepterer at levere Platformen til Dig for at give dig mulighed for at foretage betalingstransaktioner ved Zietwing forhandlere.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    11.2 Du skal give samtykke til udførelsen af en betalingstransaktion, før den kan autoriseres. Du accepterer, at Du ved at bruge Platformen til at købe et Produkt fra en Forhandler giver Zietwing samt forhandler tilladelse til at behandle betalingstransaktionen og accepterer, at når tilladelsen er givet af Dig, kan den autoriserede betalingstransaktion ikke længere ophæves. Du accepterer også, at en Forhandler kan nægte at behandle en ordre for et Produkt, uanset årsagen, og at indtil Forhandler har indsendt Betalingsordren til Zietwing i overensstemmelse med paragraf 11.4, er Zietwing ikke forpligtet til at udføre en betalingstransaktion.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    11.3 Ved at bruge Platformen vil Zietwing gemme de oplysninger, Du giver, f.eks. oplysninger om Betalingsmetode og forsendelsesoplysninger, og vil behandle betalings- og Refusionstransaktioner gennem de relevante netværk.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    11.4 Når Du har autoriseret udførelsen af en betalingstransaktion, kan Forhandler indsende Betalingsordren til Zietwing i overensstemmelse med Zietwings politikker. Ved modtagelsen af Betalingsordren fra forhandleren iværksætter Zietwing overførsel af Købesummen fra Din Betalingsmetode til forhandlerens konto på forhandlerens godkendte aftale med indløser bank, mobil betalingsløsning, bank til bank løsning eller anden. Zietwing er ikke ansvarlig for og kan ikke kontrollere, hvornår midlerne fra Din Betalingsmetode bliver overført. Zietwing foretager transaktionen gennem Zietwings betalingsgateway, men er ikke indløser og derfor ikke den ansvarlige part for hvad angår flytning af penge fra din betalingsmetode til Zietwing forhandlerens konto. Gennem oplysningerne i Din Kontos transaktionshistorik får Du besked, når Forhandler har indsendt Betalingsordren til Zietwing, så du kan se kommende transaktioner.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    11.5 Betalingstransaktioner kan afvises i din konto eller forsinkes/afvises som fastsat i paragraf 6.5.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    11.6 Du giver herved udtrykkeligt Zietwing tilladelse til (eller får en tredjepart til) at:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Opkræve eller debitere Din Betalingsmetode som nødvendigt for at gennemføre behandlingen af en betalingstransaktion,\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Kreditere Din Betalingsmetode de beløb, som kan være nødvendige for at udføre en tilbageførsel af en betalingstransaktion, refusioner eller justering af Købesummen, via Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    11.7 Du accepterer og anerkender, at:\n  ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Forhandlerens salg af Produkter er transaktioner mellem Forhandler og Dig og ikke med Zietwing, eller nogen af dets tilknyttede virksomheder, medmindre Zietwing eller en af dennes tilknyttede virksomheder er udtrykkeligt betegnet som Forhandler eller Bruger i transaktionen, og\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Hverken Zietwing, eller dennes tilknyttede virksomheder er Bruger, Forhandler eller er part i forbindelsen med betalingstransaktioner, medmindre dette udtrykkeligt er angivet i fortegnelsen for Produktet, på et Zietwing-website.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    11.8 For køb af abonnementer/tilbagevendende transaktioner:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n    · Dit abonnement starter, når Du klikker på "Acceptér og køb" (eller tilsvarende) på et abonnementskøb. Dette er en tilbagevendende faktureringstransaktion. Medmindre andet er angivet, gælder Dit abonnement og den relevante faktureringstilladelse uendeligt, indtil den annulleres af dig i din konto.\n  '
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n    · Ved at klikke på "Acceptér og køb" (eller tilsvarende) tillader Du den gældende Forhandler at fakturere Din valgte Betalingsmetode for købesummen i abonnementsperioden. Dette beløb bliver debiteret via Din betalingsmetode, indtil Du annullerer Dit abonnement, medmindre andet er angivet i de tilhørende vilkår og betingelser. Den fakturerede pris kan ændres af Forhandler i abonnementsperioden.\n  '
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Din Betalingsmetode faktureres for hver periode på basis af datoen for købet af abonnementet.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Du kan til enhver tid annullere et abonnement, men annulleringen træder ikke i kraft indtil udgangen af den aktuelle faktureringsperiode. Du vil ikke modtage refusion for den aktuelle faktureringsperiode. Dit abonnement er altid baseret og underlagt forhandlerens handelsbetingelser som du accepterer ved ethvert køb gennem Zietwing.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Zietwing forbeholder sig ret til at udstede refusioner eller kreditter. Hvis Zietwing udsteder en refusion eller kredit, er Zietwing ikke forpligtet til at udstede den samme eller lignende refusion på noget tidspunkt i fremtiden.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("12. Tilladte Finansieringstransaktioner")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    12.1 Du må kun bruge Platformen til at foretage en betalingstransaktion for et Produkt, der er købt i god tro fra en Zietwing forhandler gennem et legitimt salg af Produktet. Platformen må ikke bruges til at behandle en betalingstransaktion eller på anden måde overføre en pengemæssig værdi til en Forhandler, der ikke er relateret til et køb af et Produkt/ydelse.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    12.2 Platformen må ikke bruges til at modtage kontante forskud fra Forhandlere eller til at fremme købet af likvider (rejsechecks, forudbetalte kort, postanvisninger osv.). Du må ikke bruge Platformen til at:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Foretage betalingstransaktioner i forbindelse med salg eller udveksling af varer eller tjenesteydelser, som er ulovlige at sælge eller købe i det land, hvor Du er bosiddende eller har adgang til Platformen fra,\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Foretage betalingstransaktioner i forbindelse med salg eller udveksling af varer eller tjenester, der er ulovlige at sælge eller købe i det land, hvor Forhandler er bosiddende eller bruger Platformen, eller\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Bruge Platformen i forbindelse med enhver anden underliggende ulovlig transaktion.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    12.3 Du accepterer, at Du ikke vil bruge Platformen til at behandle betalingstransaktioner for Produkter, der er i strid med Aftalen, andre politikker eller regler gældende for Platformen (som de kan blive opdateret fra tid til anden) eller gældende lovgivning. Manglende overholdelse af disse begrænsninger kan resultere i suspendering eller opsigelse af Din brug af Zietwing Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("13. Servicegebyrer, valutaveksling, renter")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    13.1 Zietwing opkræver ikke noget gebyr for brug af Platformen for dig som bruger. Dog kan andre skatter eller omkostninger, der pålægges af tredjeparter såsom Zietwing Forhandlere, gælde for Din brug af Platformen. Du accepterer og forstår f.eks., at den finansielle institution, Zietwing Forhandleren har valgt, eller den betalingsudbyder, der udsteder Din betalingsmetode, kan opkræve et gebyr i forbindelse med debitering eller opfyldning af Betalingsmetoden. Du bør læse de vilkår og betingelser, der vedrører ovenstående, for at få yderligere oplysninger om sådanne gebyrer.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    13.2 Zietwing udfører ikke valutaveksling som en del af Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    13.3 Zietwing opkræver ikke renter for Din brug af Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("14. Tvister")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    14.1 Zietwing stiller forskellige værktøjer til rådighed for at hjælpe Dig med at kommunikere med Forhandler i tilfælde af en tvist, der måtte opstå i forbindelse med en transaktion, der behandles gennem Platformen. Hvis Du ikke er i stand til at løse en tvist, kan Zietwing mægle i en tvist mellem Dig og en Forhandler, hvis en af parterne anmoder om bistand. Hvis dette er tilfældet, gennemgår Zietwing tvisten og foreslår en ikke-bindende løsning, hvis det er relevant.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    14.2 Zietwing kan tilbyde feedback eller en anden form for bedømmelse som en hjælp til Dig til at evaluere Dine erfaringer med Platformen. Du anerkender, at en sådan feedback eller anden form for bedømmelse udelukkende repræsenterer en mening udtrykt af de andre brugere af Platformen og ikke udgør en mening, erklæring eller garanti fra Zietwing's side med hensyn til andre brugere af Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    14.3 Krav eller Tvister, der måtte opstå i henhold til denne Aftale eller som følge af Zietwings levering af Platformen, skal i første omgang henvises til Zietwing's kundeservice via e-mail til info@zietwing.com.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("15. Refusioner og indløsning")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    15.1 I tilfælde af en Refusionstransaktion fra en Forhandler eller Zietwing vil midlerne krediteres tilbage til Din Betalingsmetode.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    15.2 Hvis Du efter opsigelse af en aftale, måtte have penge til gode for produkt/ydelse købt ved Forhandleren, og såfremt der er sket en vellykket gennemførelse af relevante kontroller vedrørende hvidvaskning af penge, svig og andre ulovlige aktiviteter, vil Zietwing kunne være behjælpelig med at foretage en refusion på det beløb for de udestående penge og iværksætte overførsel af beløbet til Din betalingsmetode efter opsigelsen. I sådanne tilfælde skal Du kontakte din Forhandler, som kan være behjælpelig i den videre proces.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    15.3 Hvis den udestående sum ikke kan indløses i overensstemmelse med paragraf 15.2, kan du efter opsigelse af Aftalen anmode Forhandleren af produkt/ydelse om at foretage en bank overførsel eller tilsvarende, af det resterende beløb i sin helhed.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    15.4 Intet i paragraf 15.3 begrænser Zietwings ret til at opsige Aftalen i henhold til paragraf 18.4 og/eller til indløsning i henhold til paragraf 15.2.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("16. Dit ansvar")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    16.1 I tilfælde af en uautoriseret betalingstransaktion kan du være berettiget til at kunne foretage en chargeback på beløbet, vel og mærke hvis du kan dokumentere at denne transaktion er uautoriseret. Zietwing har intet ansvar i forhold til sådanne og kan derfor ikke holdes økonomisk ansvarlig. For at foretage en chargeback/tilbageførsel grundet uautoriseret transaktion skal du kontakte din betalingsmetode/kortudsteder/bank for tilbageførsel.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    16.2 Zietwing vil på Din anmodning øjeblikkeligt være behjælpelig i at spore betalingstransaktionen og underrette Dig om resultatet hvis du oplyser om os en potentiel uautoriseret transaktion. Kontakt os venligst ved at sende e-mail til info@zietwing.com.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    16.3 Hvis Du har handlet svigagtigt eller med forsæt eller på grund af grov uagtsomhed har undladt at overholde de dele af Aftalen, der vedrører Din Konto, vil Du være ansvarlig for alle tab dette måtte medføre.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("17. Godkendelse af Produkter")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    17.1 Zietwing repræsenterer eller godkender ikke og er ikke ansvarlig for:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Sikkerheden, kvaliteten, nøjagtigheden, integriteten eller lovligheden af nogen Produkter, sandheden eller rigtigheden af beskrivelsen af Produkter eller noget Indhold, der vises eller distribueres, købes eller betales via Platformen, eller\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Din evne til at købe Produkter eller Forhandlerens evne til at levere Produkter til Dig.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    17.2 Zietwing forbeholder sig ret til, men har ikke noget ansvar for, at redigere, ændre, afvise indlæg eller fjerne ethvert indholdselement, helt eller delvist, som efter Zietwings eget skøn er anstødeligt, fejlagtigt, ulovligt, svigagtigt eller på anden måde i strid med Aftalen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("18. Afslutning af Dit forhold til Zietwing")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    18.1 Aftalen er gældende, indtil den opsiges af enten Dig eller Zietwing som beskrevet nedenfor.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    18.2 Hvis Du ønsker at opsige Din juridiske aftale med Zietwing, kan Du gøre det straks og uden beregning til enhver tid ved at:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · lukke og slette din Konti der er tilknyttet Platformen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    18.3 Zietwing kan til enhver tid opsige sin juridiske aftale med Dig uden varsel, hvis:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Du har overtrådt en væsentlig bestemmelse i denne Aftale (eller har handlet på en måde, der klart viser, at Du ikke har til hensigt eller er ude af stand til at overholde de væsentlige bestemmelser i denne Aftale), eller\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Zietwing er forpligtet ved lov til at gøre dette (f.eks. hvor leveringen af Platformen til Dig er eller bliver ulovlig).\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    18.4 Medmindre der er fastsat en kortere periode i denne Aftale, som er tilladt i henhold til lov, kan Zietwing til enhver tid opsige Aftalen ved at give Dig 14 dages varsel.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    18.5 Når denne Aftale ophører, skal alle de juridiske rettigheder, forpligtelser og ansvar, som Du og Zietwing har nydt godt af, være underlagt (eller som er opstået, mens Aftalen har været i kraft), eller som udtrykkeligt skal fortsætte på ubestemt tid, være uberørt af dette ophør, og bestemmelserne i paragraf 23.6 skal fortsat gælde for sådanne rettigheder, forpligtelser og ansvar på ubestemt tid.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("19. Udelukkelse af garantier")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    19.1 Zietwing, dets datterselskaber og tilknyttede virksomheder (og deres licensgivere) giver ingen udtrykkelige garantier eller erklæringer med hensyn til levering af tjenesterne.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    19.2 Det gælder specifikt, at Zietwing, dets Datterselskaber og tilknyttede virksomheder (og deres licensgivere) ikke repræsenterer eller garanterer for Dig, at:\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v("\n      Din brug af tjenesterne vil opfylde Dine krav,\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Din brug af tjenesterne vil være uafbrudt, til tiden, sikker eller fri for fejl, og\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Alle oplysninger, som Du har fået som resultat af Din brug af Platformen, vil være nøjagtige eller pålidelige.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    19.3 Ingen betingelser, garantier eller andre vilkår (herunder eventuelle stiltiende vilkår såsom tilfredsstillende kvalitet, egnethed til formålet eller overensstemmelse med beskrivelsen) er gældende for tjenesterne undtagen i det omfang, at de udtrykkeligt er fastsat i Aftalen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    19.4 Intet i Aftalen påvirker disse lovfæstede rettigheder, som Du altid har ret til som forbruger, og som Du ikke kontraktligt kan acceptere at ændre eller give afkald på.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("20. Ansvarsbegrænsning")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    20.1 Intet i Aftalen udelukker eller begrænser Zietwings ansvar for tab, der ikke lovligt kan udelukkes eller begrænses i henhold til gældende lov.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    20.2 I henhold til paragraf 19.1 ovenfor, vil Zietwing, dets Datterselskaber og Tilknyttede virksomheder (og dets licensgivere), ikke være ansvarlige over for Dig for:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Indirekte eller efterfølgende tab, Du måtte have pådraget Dig. Dette omfatter tab af fortjeneste (uanset om det er pådraget direkte eller indirekte), tab af goodwill eller forretningsmæssigt omdømme eller tab af data, som Du pådrager Dig,\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "\n      Tab eller skade, Du måtte pådrage Dig som følge af:\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Tillid, Du har udvist for fuldstændighed, nøjagtighed eller eksistensen af annoncering, eller som et resultat af forbindelser eller transaktioner mellem dig og en annoncør, sponsor eller produkter/ydelser fra en Zietwing sælgende virksomhed.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Ændringer, som Zietwing kan foretage for tjenester eller enhver permanent eller midlertidig afbrydelse i leveringen af ​tjenester (eller alle funktioner inden for tjenesterne),\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", [_c("li", [_vm._v("\n      Fejl i tjenesterne,\n    ")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Sletning, beskadigelse eller manglende lagring af kommunikationsdata, der vedligeholdes eller transmitteres af eller via Din brug af tjenesterne,\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Manglende levering af nøjagtige kontooplysninger fra Din side til Zietwing og\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v("\n      Enhver svigagtig brug af tjenesterne af Dig.\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    20.3 Dog kompenserer Zietwing dig for eventuelle gebyrer, som Du pådrager dig som følge af manglende eller forkert udførelse af en betalingstransaktion fra Zietwings side.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("21. Ændringer af Aftalen")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    21.1 Du accepterer, at Zietwing til enhver tid kan foretage ændringer af Aftalen. Når disse ændringer er gennemført, vil Zietwing, medmindre en kortere periode er fastsat i denne Aftale, i overensstemmelse med gældende lov give Dig et varsel om sådanne ændringer enten via e-mail sendt til Din e-mailadresse før den foreslåede ikrafttrædelsesdato, eller ved at oplyse dette i din konto.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    21.2 Du forstår og accepterer, at Du vil blive anset for at have accepteret ændringerne, medmindre Du meddeler Zietwing det modsatte, sådan som det er fastsat i paragraffen\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    21.3 Forud for den dato, hvor ændringerne træder i kraft, i hvilket tilfælde Aftalen ophører uden beregning umiddelbart før ikrafttrædelsesdatoen for ændringerne. Du har også ret til at opsige denne Aftale umiddelbart og uden gebyrer på ethvert tidspunkt inden ikrafttrædelsesdatoen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    21.4 Intet i paragraf 21 begrænser:\n  ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Zietwings ret til at opdatere og revidere sin politik til enhver tid eller at tilføje nye funktioner til enhver tid uden forudgående varsel, som kan accepteres af Dig, ved at Du bruger den nye funktion. Sådanne revisioner kan finde sted ved hjælp af en metode udvalgt af Zietwing og denne metode kan omfatte kommunikation via e-mail, eller offentliggørelse på din konto, eller en Zietwing webside.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Parternes ret til at ændre vilkårene i denne paragraf 21, hvor ændringen ikke er forbudt ved lov, og begge parter accepterer den.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    21.5 Ændringer af en Ureguleret Tjeneste.\n  ")]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("22. Kommunikation og underretninger")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    22.1 Alle oplysninger vil blive gjort tilgængelige eller leveret til Dig på en let tilgængelig måde, på et let forståeligt sprog, i en klar og forståelig form og på Dansk.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    22.2 Opgørelser, underretninger og andre meddelelser til Dig kan ske med post, e-mail, opslag på din Zietwing konto eller andre rimelige midler.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    22.3 Zietwing kan kommunikere med dig om tjenesterne ved hjælp af elektronisk kommunikation, herunder (a) sende e-mail til Din e-mailadresse, (b) udsendelse af meddelelser eller meddelelser på din Zietwing konto. Du accepterer, at Zietwing kan sende elektroniske meddelelser til Dig i forbindelse med Din brug af tjenesterne, herunder Aftalen (og revisioner eller ændringer af Aftalen), meddelelser om tjenesterne og godkendelse af betalinger. Visse meddelelser vil blive behandlet således:\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      Ved tilmelding modtager du en e-mail som bekræfter din tilmelding\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Ændringer i denne Aftale efter tilmeldingen vil blive sendt via e-mail til Din e-mailadresse, eller oplyses inde på din Zietwing konto.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Undtagen hvor denne Aftale angiver andet, sendes der en meddelelse om ophør af denne Aftale i en e-mail til Din e-mailadresse.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Der vil være adgang til oplysninger om betalings- og Refusionstransaktioner i Din Zietwing Kontos transaktionshistorik på nettet.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Der vil være adgang til oplysninger om afvisningen af betalings- og Refusionstransaktioner i Din Kontos transaktionshistorik på nettet.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Der vil være adgang til oprettede betalingsmetoder på din Zietwing Konto.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    22.4 Du bør opbevare kopier af elektronisk kommunikation ved at udskrive en papirkopi eller gemme en elektronisk kopi, og oplysninger, Du har modtaget i elektronisk format, leveres til Dig ud fra den forudsætning, at Du er i stand til at udskrive eller gemme disse oplysninger.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n    22.5 Enhver meddelelse, der sendes til Zietwing i henhold til Aftalen, skal sendes med anbefalet post til Zietwing, Egå havvej 21, 8250 Egå, Danmark att.: "ZIETWING ", med undtagelse af:\n  '
        )
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      Meddelelser om tab, tyveri, uautoriseret brug eller sikkerhedsbrud skal hurtigst muligt sendes via e-mail til info@zietwing.com.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Meddelelser om opsigelse af denne Aftale skal sendes til e-mail til "
          ),
          _c("a", { attrs: { href: "mailto:info@zietwing.com" } }, [
            _vm._v("info@zietwing.com")
          ]),
          _vm._v(
            ", dog skal du selv opsige din konto ved at logge ind og de-aktiverer dine abonnementer og derefter slette kontoen.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Meddelelser i henhold til paragraf 20.2 skal sendes e-mail til info@zietwing.com\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    22.6 Du kan se Dine transaktioner i transaktionshistorikken for Din Konto på nettet, der opdateres jævnligt, og Du accepterer ”ikke” at modtage papirudskrifter.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("23. Generelle juridiske termer")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    23.1 Overskrifterne til paragrafferne i denne Aftale har udelukkende til formål at fungere som referencer og har ingen betydning for fortolkningen eller opbygningen af Aftalen.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    23.2 Henvisninger til vedtægter eller lovbestemmelser omfatter en henvisning til den pågældende vedtægt eller lovbestemmelse, som til enhver tid kan ændres, udvides eller genindføres.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    23.3 Medmindre andet udtrykkeligt fremgår af Aftalen, er alle nævnte beløb i Aftalen angivet i DKK.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    23.4 Aftalen udgør hele den juridiske aftale mellem dig og Zietwing og regulerer Din brug af tjenesterne (men udelukker alle tjenester, som Zietwing kan levere til dig i henhold til en separat skriftlig aftale), og erstatter fuldstændigt eventuelle tidligere aftaler mellem dig og Zietwing i forhold til tjenesterne.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    23.5 Du accepterer, at såfremt Zietwing ikke udøver eller håndhæver en juridisk ret eller et retsmiddel, som er indeholdt i Aftalen (eller som Zietwing nyder fordel af i henhold til en gældende lov), vil dette ikke blive anset for at være en formel frafaldelse af Zietwings rettigheder, og at disse rettigheder eller retsmidler stadig er til rådighed for Zietwing.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    23.6 Såfremt en domstol, der har kompetence til at træffe afgørelse om en sag vedrørende Aftalen, afgør, at en bestemmelse i Aftalen er ugyldig, bliver denne bestemmelse fjernet fra Aftalen uden at påvirke resten af Aftalen. De tilbageværende bestemmelser i denne Aftale vil fortsat være gyldige og kunne håndhæves.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    23.7 Du må ikke overdrage fordelen af Aftalen eller på anden måde give den i underentreprise eller overføre Dine rettigheder eller forpligtelser i henhold til Aftalen uden forudgående skriftlig godkendelse fra Zietwing. Zietwing kan tildele fordelen eller på anden måde give den i underentreprise eller overføre sine rettigheder og forpligtelser i henhold til aftalen til tredjemand uden varsel til Dig og uden Dit samtykke.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    23.8 Du anerkender og accepterer, at alle medlemmer af den gruppe af selskaber, for hvilken (Zietwing) er moderselskab, er tredjepartsbegunstigede i Aftalen, og at sådanne andre selskaber vil være berettigede til direkte at håndhæve og gøre en bestemmelse i Aftalen gældende, som tildeler dem en fordel (eller rettigheder til deres fordel). Med undtagelse af dette er ingen anden person eller virksomhed en begunstiget tredjepart i denne Aftale.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    23.9 Aftalen og Dit forhold til Zietwing i henhold til Aftalen er reguleret af dansk lov med forbehold for de tilfælde, hvor en given sag ifølge den relevante EU-lovgivning er reguleret af lovgivningen i et andet land. Du og Zietwing accepterer at underlægge jer den eksklusive jurisdiktion af den danske domstol for at løse eventuelle juridiske spørgsmål, der måtte opstå på grundlag af denne Aftale, med forbehold for de tilfælde, hvor en given sag ifølge den relevante EU-lovgivning kan løses ved domstolene i et andet land. Uanset denne paragraf 23.9 accepterer Du, at Zietwing stadig vil være berettiget til at ansøge om retsmidler, der omfatter et påbud (eller en tilsvarende type af presserende juridiske retsmidler) i enhver jurisdiktion.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("24. Privatlivspolitik")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _c("br"),
        _vm._v(
          " Denne privatlivspolitik gælder for Zietwing, samt tilhørende datterselskaber. Dette gældende Zietwing platformen og Zietwing.com som disse betingelser danner grundlag for.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    24.1 Behandling af dine personoplysninger. Formålet med denne privatlivspolitik er at fortælle, hvordan vi indsamler, beskytter og anvender dine personoplysninger. Beskyttelse af dine personoplysninger er afgørende for måden Zietwing indsamler og behandler dine oplysninger på. Zietwing lægger følgende principper til grund ved indsamling og behandling af dine personoplysninger:\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      Du bestemmer selv over de data, vi indsamler om dig.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Uanset hvorfra disse oplysninger indsamles, eller hvor de opbevares, behandler Zietwing dine personoplysninger i henhold til den til enhver tid gældende Lov om behandling af personoplysninger med tilhørende sikkerhedsbekendtgørelse.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Zietwing sikrer, at dine personoplysninger ikke bliver ændret til noget ukorrekt, bliver kendt af uvedkommende eller på anden måde misbruges.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Zietwing indsamler kun personoplysninger om dig, som er nødvendige for at stille Zietwings ydelser til rådighed for dig.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Zietwing videregiver ikke dine personoplysninger til andre databehandlere udover dem som er nødvendige for at stille Zietwing platformens ydelser og produkter til rådighed for dig.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Ved at framelde dig Zietwing platformen kan du gøre dine personoplysninger utilgængelige for fremadrettet anvendelse. Historiske oplysninger, som opbevares af hensyn til Zietwings tekniske og sikkerhedsmæssige revisionsspor kan ikke påregnes slettet, men disse vil blive anonymiseret.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Du kan til enhver tid ændre de registrerede personoplysninger i din konto via Zietwing platformen.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    24.2 Anonym anvendelse af hjemmesider\n    "),
        _c("br"),
        _vm._v(
          " Du kan altid søge information på Zietwings hjemmesider uden at afgive personoplysninger. Zietwing opsamler ikke automatisk personoplysninger og linker heller ikke anonymiserede tekniske oplysninger med specifikke brugere.\n    "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" 24.3 Anvendelse af cookies\n    "),
        _c("br"),
        _vm._v(
          " En cookie er en lille datafil med information, som en hjemmeside gemmer på din computers harddisk. Cookies gør, at hjemmesiden kan genkende din computer og bruges bl.a. til at forbedre brugervenligheden og til indsamling af anonymiseret statistik. Cookies anvendes også ifm. styring af log-on til Zietwing platformen - disse cookies slettes igen, når du logger af Zietwing platformen. De fleste virksomheder anvender cookies på deres hjemmesider for at forbedre brugervenligheden.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    Zietwing anvendelse af cookies:\n  ")]),
      _vm._v(" "),
      _c("ol", { attrs: { start: "1", type: "1" } }, [
        _c("li", [
          _vm._v(
            "\n      Cookies til indsamling af statistiske oplysninger om brugen af Zietwing platformen:\n      "
          ),
          _c("br"),
          _vm._v(" Se afsnittet ”Cookies og statistik”.\n    ")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Cookies, der anvendes til at håndtere log-on til Zietwing platformen samt til at optimere din brugeroplevelse:\n      "
          ),
          _c("br"),
          _vm._v(" Se afsnittet ”Cookies og brugerstyring”.\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Det er en forudsætning, at du accepterer cookies for at kunne benytte Zietwing.com samt Zietwing platformen.\n    "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" 24.4 Cookies og statistik\n    "),
        _c("br"),
        _vm._v(
          " Zietwing anvender cookies til at indsamle anonymiserede oplysninger om brugen af Zietwing platformen samt besøg på Zietwing’s’sider. Der indsamles oplysninger om:\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [_vm._v("\n      Hvilke sider du besøger\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Tidspunkt for besøg\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Hvilke sider du kom fra.\n    ")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Zietwing indhenter ligeledes oplysninger om den pc, du logger på fra (ikke personoplysninger). Oplysningerne omfatter:\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v("\n      Internetbrowser og browserindstillinger\n    ")
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Operativsystem\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Internetforbindelse\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Skærmopløsning og -indstillinger\n    ")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Oplysningerne anvendes til statistiske formål og til at forbedre Zietwing tjenesterne.\n    "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          " Udover dette registrerer vi den IP-adresse, du tilgår Zietwing platformen fra. Denne information sammenstilles ikke med dine personoplysninger, men kan anvendes under efterforskning af misbrug eller forsøg på misbrug af din Zietwing brugerkonto.\n    "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" 24.5 Cookies og brugerstyring\n    "),
        _c("br"),
        _vm._v(
          " Zietwing anvender cookies til brugerstyring og til at optimere brugeroplevelsen af Zietwing platformen. Disse cookies benyttes bl.a. til at registrere:\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [_vm._v("\n      Sprogindstillinger\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Log-on-metode\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Indstillinger for arkiv\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Sorteringsvalg\n    ")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Kontaktinformation (i forbindelse med henvendelser til brugersupport)\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Styring af log-on-sessionen\n    ")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    24.6 Sikkerhed\n    "),
        _c("br"),
        _vm._v(
          " For at sikre dine personlige oplysninger mod uautoriseret adgang eller ændring, tab, forvanskning og anden misbrug, anvender Zietwing en række tekniske og organisatoriske foranstaltninger.\n    "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          " Vores medarbejdere og databehandlere er underlagt tavshedspligt med hensyn til de oplysninger, der behandles i Zietwing’s systemer.\n    "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          " Når du bliver bedt om at afgive personoplysninger, sker det altid via en sikker krypteret forbindelse.\n    "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" 24.7 Markedsføring\n    "),
        _c("br"),
        _vm._v(
          " Zietwing sælger eller videregiver aldrig dine personoplysninger med henblik på markedsføring fra andre. Zietwing anvender udelukkende oplysninger om din e-mail adresse og mobiltelefonnummer til at servicere dig i forhold til Zietwing platformens services.\n    "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" 24.8 Rettigheder\n    "),
        _c("br"),
        _vm._v(
          " Alt materiale på Zietwing.com websitet, samt Zietwing platformen, herunder navne, logoer, varemærker, grafik, tekster, ikoner og billeder, tilhører Zietwing og samarbejdspartnere, og er beskyttet i henhold til varemærkeloven, ophavsretsloven og anden lovgivning.\n    "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br")
      ]),
      _c("h3", [_vm._v("26. Links til andre serviceudbydere")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        " På Zietwing platformen kan der være links, henvisninger til andre serviceudbyderes hjemmesider. Zietwing er ikke ansvarlig for indholdet af andre serviceudbyderes hjemmesider, og denne privatlivspolitik gælder ikke for disse serviceudbyderes hjemmesider.\n  "
      ),
      _c("p"),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("27. GDPR")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n    For at sikre, at Zietwing lever op til sine forpligtelser under de nationale databeskyttelsesregler samt Europa-Parlamentet og Rådets forordning (EU) 2016/279 ("GDPR"), har Zietwing etableret Data behandler aftaler med samtlige involverede parter som er medvirkende til at Zietwing kan leverer servicen til dig som bruger, Dette sikrer at hele kæden fra a til z overholder samme regler omkring persondata og derved overholder gældende EU lovgivning. Ligeledes har vi udarbejdet nedenstående Erklæring om databeskyttelse ved brug af Zietwing som du accepterer ved at benytte Zietwing’s services eller hjemmeside.\n  '
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("28. Databeskyttelse")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    ZIETWING - ERKLÆRING OM DATABESKYTTELSE VED BRUG AF ZIETWING\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n    Zietwing drives af Zietwing, adresse: Egå havvej 21, 8250 Egå, Danmark (herefter “vi”, “os”, “vores”, “Zietwing"). Denne Erklæring om databeskyttelse ("Erklæring") tilligemed Zietwing’s betingelser for brug ("Brugerbetingelser") og Cookies Politik angiver det grundlag hvorpå alle oplysninger eller persondata, som vi indsamler fra brugere, eller som du giver os, vil blive behandlet af Zietwing. Denne Erklæring gælder for Zietwing, samt websiden Zietwing.com og alle ydelser der tilbydes af Zietwing, Eventuelle Zietwing mobil app og andre midler forbundet hermed (så som kontakt til vores kundeserviceteam). Oplysninger der gives af dig, vil blive opbevaret af os som dataansvarlig.\n  '
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    I det følgende fremlægges vores informationsindsamlings- og -formidlingspraksis vedrørende Zietwing. For fuld forståelse af dine rettigheder opfordres du til at læse denne Databeskyttelse samt brugerbetingelserne. Hver gang du bruger Zietwing, vil du være bundet af den gældende Erklæring og du rådes til at gennemlæse dette hver gang du bruger Webstedet.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Zietwing forbeholder sig ret til at ændre denne Erklæring til hver en tid, helt eller delvis i henhold til Sektion 10.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("29. Accept af denne erklæring om persondata")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Ved brug af Zietwing, tilkendegiver du din accept af denne Erklæring om databeskyttelse. Hvis du er uenig i et punkt i denne Erklæring om databeskyttelse, må du ophøre med at bruge Zietwing. Vi forbeholder os ret til at ændre denne Erklæring om databeskyttelse til hver en tid i henhold til Sektion 10.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("30. Persondata som Zietwing indsamler om dig")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Vi vil indsamle og behandle følgende af dine persondata:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Browsing Information - Når du bruger Zietwing systemet eller benytter dig af tjenester relateret til dette, indsamles dine persondata af Google Analytics Heri er indbefattet:\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      Automatisk indsamlede oplysninger: Visse personlige og ikke-personlige oplysninger modtages og indsamles sommetider automatisk fra dig/din maskine/webbrowser når du besøger Zietwing. Vi modtager og indsamler navn på det domæne og den vært hvorfra du har adgang til Internet; Internet protokol (IP) adressen på den computer du bruger; det browser software du bruger og dit driftssystem og dato og tidspunkt for din adgang til Webstedet.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [
        _vm._v("31. Du kan vælge at give os følgende personoplysninger:")
      ]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Når du bruger Zietwing, modtager og indsamler vi information og personoplysninger om dig, kaldet “Personlige kundeoplysninger”. Vi kan indsamle og behandle følgende Personlige kundeoplysninger om dig:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    Oplysninger du giver\n  ")]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      De oplysninger du giver os, når du opretter din konto, og derefter bruger Zietwing, benytter dig af tjenester, køber produkter gennem en Zietwing forhandler, bruger booking systemet eller kontrollerer dine betalinger. Disse oplysninger kan omfatte dit navn din fødselsdato, telefonnummer, e-mailadresse, fakturerings adresse, leveringsadresse, telefonnummer, kreditkortoplysninger.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Hvis du vælger at købe et produkt gennem en Zietwing forhandler, kan det være nødvendigt at svarer på forskellige spørgsmål ved denne forhandler, eller ved det eksakte forhandler produkt, dette kunne være nødvendige produktoplysninger, Information som gør det nemmere for denne forhandler at leverer sit produkt, eller anden information en forhandler måtte ønske du svarer på. Disse informationer er tilknyttet den enkelte forhandler og det er forhandleren der danner disse spørgsmål, det er derfor dit ansvar ikke at oplyse følsomme oplysninger ved disse forespørgsler.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [
        _vm._v("32. Hvordan og hvorfor vi bruger din personoplysninger")
      ]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n    Det følgende skema redegør for det juridiske grundlag ("Juridisk grundlag") og grundene til ("Formål") at vi behandler dine Personoplysninger:\n  '
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    32.1 Juridisk grundlag\n  ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Det er nødvendigt at behandle dine personoplysninger for at indgå og udføre vores service til dig vedrørende dit brug af Zietwing som omhandlet i "
        ),
        _c("u", [_vm._v("brugerbetingelser.")])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    32.2 Adgang til Zietwing\n  ")]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      For at give dig adgang til ZIetwing og tilladelse til at bruge Zietwing\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    32.3 Opfylde dine køb, bookinger og anmodninger\n  ")
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      For at give dig mulighed ved at købe, bestille, booke produkter gennem en forhandler.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Registrere, behandle og effektuere dine køb og/eller reservationer.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Administrere din kundekonto.\n    ")])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    32.4 Legitime Interesser\n  ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Data behandles på dette grundlag, når det er i vores legitime interesse at behandle data, som ikke påvirker din frihed og dine rettigheder.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Vi indsamler og behandler personoplysninger med det formål at forbedre og kontrollere Zietwing’s effektivitet og forbedre din brug af Zietwing.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Hvis du køber et produkt, eller benytter Zietwing behandler vi dine personoplysninger for at besvare de forespørgsler eller anmodninger du eller en forhandler har forelagt angående Zietwing.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    32.5 Forbedring af Zietwing Funktion og Effektivitet\n  ")
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      For at sørge for, forbedre, afprøve og kontrollere ZIetwing’s effektivitet.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Sikre at Zietwing’s indhold præsenteres på den mest effektive måde for dig og forbedre din brug af Zietwing.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    32.6 Svar på forespørgsler og klager\n  ")]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      Behandle og svare på alle forespørgsler, anmodninger og klager du måtte indgive til os via mail info@zietwing.com.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Svare på og bearbejde enhver anmodning fra dig eller den forhandler du har en forhold med.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Få din mening om Zietwing og vores ydelser tilknyttet Zietwing.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    32.7 Underrette dig om ændringer\n  ")]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      Underrette dig om ændringer i Zietwing og/eller i relaterede tjenesteydelser.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Underrette dig om dine foretagne bookinger, eller Bookinger foretaget på dine vegne af en forhandler.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Underrette dig om dine foretagne køb, og dertil fremsendelse af fakturaer.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Underrette dig om evt. overskredne betalinger, såsom hvis din betalingsmetode ikke kan foretage et allerede bestilt køb.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Underrette dig hvis en forhandler ændrer ved dit abonnement.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Minde dig om en kommende betaling.\n    ")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Give dig oplysninger om eventuelle ændringer for en booking du har foretaget.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Zietwing beholder dine oplysninger så længe Zietwing har en legitim interesse i at opbevare sådanne, heri indbefattet undersøgelse af misbrug og retlige formål.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    32.8 Retlige formål:\n  ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Endelig kan vi, i særlige tilfælde, have behov for at bruge dine oplysninger for at bearbejde og løse retlige tvister, for lovbestemte undersøgelser overholdelse af gældende lov, håndhæve Vilkår for brug Zietwing eller efterkomme lovmæssige krav om håndhævelse af loven.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("33. Modtagere af dine personoplysninger")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n    Vi meddeler dine personoplysninger til eventuelle Zietwing forhandlere som du handler med, eller har anmodet om at ville handle med, derudover vores datterselskaber, vores øverste moderselskab og dets datterselskaber ("Zietwing") som leverer visse tjeneste- og produktaspekter der leveres igennem Zietwing. Vi meddeler ligeledes eventuelle partnere zietwing forhandleren benytter for at kunne leverer sit produkt til dig, såsom regnskabssystem, rykker proces, Inkasso, sms service, advokat.\n    '
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" Vi meddeler kun dine personoplysninger til tredjemænd "),
        _c("u", [_vm._v("uden for")]),
        _vm._v(" Zietwing under følgende betingelser:\n  ")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    33.1 Modtagere: forhandlere i Zietwing\n  ")]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [_vm._v("\n      For at bekræfte din registrering.\n    ")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Zietwing overfører relevante oplysninger fra dig til den forhandler der skal leverer din valgte ydelse, så forhandleren kan levere ydelsen. Det drejer sig om oplysninger vedrørende navn og kontakt informationer, betalingsbeløb, betalings dato, betalingsmetode samt tillige med de oplysninger den eksakte forhandler måtte anmode dig om i forbindelse med ydelsen.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      I tilfælde af strid vedrørende et køb/ydelse, kan vi efter behov give oplysninger om accept af køb, købsdato mm. Dette kan omfatte en kopi af bekræftelsen på dit løb, samt accept af betalingen ved indløser banken som bevis for at du reelt har foretaget et køb.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      For at kontrollere gyldigheden af ydelser der er købt/foretaget via din Zietwing konto ved den respektive forhandler.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      For at kunne foretage betaling på din valgte betalingsmetode.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      For at kunne igangsætte rykker proces, ved manglende betaling.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      For at kunne sende dig SMS\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      For at kunne sende dig fakturaer\n    ")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      For at kunne tilbyde dig produkter og andre ydelser\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    *VIGTIGT*- Du bedes venligst bemærke at vi ikke deler dine bank informationer, kort oplysninger med den respektive forhandler, men disse informationer udelukkende benyttes til at foretage køb igennem vores PCI sikrede betalingsgateway på den respektive forhandleres aftale med din betalingsidentitet udbyder (Såsom NETS, VISA, MasterCard). Betydende når du tilføjer en betalingsidentitet i Zietwing eller ved en forhandler, Gemmes din betalingsidentitet ikke i Zietwing men i den PCI sikrede betalingsgateway og der anmodes den respektive Betalingsidentitet udbyder/indløser bank/udsteder bank om hvorvidt din betalingsmetode er aktiv og kan benyttes. Der kan kun foretages betalinger i gennem Zietwing hvis du har accepteret denne betaling og den respektive forhandler har en aftale til at måtte modtage betaling fra dig.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Zietwing er ikke bank og er ikke part i penge flowet, men anmoder udelukkende om hvorvidt betaling kan gennemføres, hvis dette er muligt igangsættes processen om flytning af midler igennem de respektive parter i betalingskæden. Såsom NETS, Mobile pay, VISA, MasterCard, Maestro, Betalingsservice, leverandør service mm.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    33.2 Zietwings underleverandører og tjenesteydelsesleverandører.\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      For at hjælpe Zietwing med at levere tjenester til dig som kunde/bruger.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Til forbedring af brugeroplevelse\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Rykker proces\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Regnskabssystemer\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Inkasso systemer\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      SMS services\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Betalingsanmodning\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Betalingsidentitet registrering\n    ")]),
        _vm._v(" "),
        _c("li", [_vm._v("\n      Retur betalinger\n    ")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    33.3 Regulerende myndigheder, Retshåndhævende myndigheder, Offentlige organer og andre virksomheder\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      For at efterkomme enhver relevant retlig forpligtelse, retskendelse, stævning, ransagningskendelse eller anden retlig eller forskriftsmæssig forpligtelse eller krav som Zietwing er underlagt.\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      For at beskytte rettigheder, ejendom og sikkerhed for Zietwing, vores kunder eller andre. Dette omfatter udveksling af oplysninger med andre selskaber og organisationer med henblik på beskyttelse mod misbrug og mindskning af kreditrisiko.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    For at håndhæve eller anvende brugerbetingelser eller andre aftaler eller efterforske mulige overtrædelser.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    33.4 Mulige Zietwing forhandlere eller Købere af forretningsaktiver\n  "
        )
      ]),
      _vm._v(" "),
      _c("ul", { attrs: { type: "disc" } }, [
        _c("li", [
          _vm._v(
            "\n      For at lette tredjeparts levering og salg af Zietwing systemet.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [
          _vm._v("34. Opbevaring og overførsel af dine personoplysninger")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n    Dine personoplysninger kan opbevares og overføres inden for eller uden for det Europæiske Økonomiske Samarbejdsområde ("EØS"). Vi overfører kun dine personoplysninger uden for EØS til lande hvor EU Kommissionen har afgjort at det pågældende tredjeland sikrer et tilstrækkeligt beskyttelsesniveau på linje med EU databeskyttelsesnormer eller at der er foranstaltet tilstrækkelige værn til at beskytte dine Personoplysninger. Hvis du vil vide mere om passende værn som vi har opsat til at styre overførsel af dine personoplysninger, kan du kontakte os på [info@zietwing.com].\n  '
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Desværre er transmission af information på internet ikke 100% sikker. Skønt vi altid vil gøre vores bedste for at beskytte dine personoplysninger, kan vi ikke garantere sikkerhed for oplysninger du overfører til os; al transmission foregår på dit eget ansvar. Når vi først har modtaget dine oplysninger, vil vi bestræbe os på at bruge strenge procedurer og sikkerhedselementer for at forsøge at undgå uautoriseret adgang til oplysningerne.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("35. Links")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Zietwing kan indeholde links til andre services som du kan tilkoble dig som kunde/bruger. Zietwing kan ikke holdes ansvarlig for databeskyttelse eller praksis på services leveret af andre virksomheder, derfor skal du som kunde/bruger altid sikre dig at disse services overholder de krav som du måtte have til dine persondata. Denne Databeskyttelse styrer kun information der er indsamlet på Zietwing.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Zietwing kan indeholde links til andre services leveret af tredjeparter udelukkende som en bekvemmelighed til dig. Vi tager ikke ansvar i forbindelse med en Linket service, eller ansvar i en kontrakt der er indgået mellem dig og en Linket service. Vi har ingen kontrol over services leveret til dig fra tredjeparter og vil ikke acceptere noget ansvar for dem eller for tab eller skade som måtte hidrøre fra din brug af disse linkede services.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("36. Hvor længe vi opbevarer dine personoplysninger")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Almindeligvis forventer vi at opbevare dine personoplysninger for en periode på 5 år fra den sidste dato for kontakt med dig, eller hvis du indgår I et kontraktforhold med en forhandler.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Vi opbevarer ikke betalingsoplysninger som du indgiver for at betale for en ydelse. Disse slettes i forbindelse med sletning af din konto.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Du bedes bemærke at vi under visse betingelser kan opbevare dine data for en længere periode, for eksempel, hvis vi behandler en igangværende klage eller hvis i god tro mener at loven eller en relevant tilsynsmyndighed rimeligvis i henhold til os kan forvente eller forlange at vi bevarer dine data, eller hvis vi har legitim interesse i at bevare dine data og denne legitime interesse ikke er i konflikt med dine rettigheder og friheder.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("37. Dine rettigheder og hvordan du kan udøve dem")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Nedenstående skema fremlægger din ret til at meddele os enhver forespørgsel eller bekymring du måtte have vedrørende vores behandling af dine personoplysninger:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [_c("u", [_vm._v("37.1 Ret til adgang")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Du har ret til at anmode om en kopi af de personoplysninger om dig som vi ligger inde med. Vi vil kun kræve betaling for denne anmodning om adgang hvis vi føler at anmodningen er uberettiget eller overdreven. Denne anmodning kan du foretage i din konto.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [_c("u", [_vm._v("37.2 Ret til rettelse")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Du har ret til at anmode om at vi retter enhver ukorrekt personoplysning som vi har om dig. Kontakt kan rettes til "
        ),
        _c("a", { attrs: { href: "mailto:Info@zietwing.com" } }, [
          _vm._v("Info@zietwing.com")
        ])
      ]),
      _vm._v(" "),
      _c("p", [_c("u", [_vm._v("37.3 Ret til sletning")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Du har ret til at bede os om at slette dine personoplysninger, når:\n  "
        )
      ]),
      _vm._v(" "),
      _c("ol", { attrs: { start: "1", type: "1" } }, [
        _c("li", [
          _vm._v(
            "\n      Dine personoplysninger ikke længere tjener de formål for hvilke de blev indsamlet eller på anden måde behandlet af os;\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Du trækker dit samtykke tilbage og der ikke er nogen anden lovmæssig grund til at vi behandler dine personoplysninger;\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Du gør indsigelse mod behandlingen og der ikke er nogen berettigede særdeles vægtige grunde til behandlingen;\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Dine personoplysninger er blevet behandlet ulovligt; eller\n    "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n      Dine personoplysninger skal slettes for at efterkomme en retlig forpligtelse.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Det er muligt vi ikke kan efterkomme din begæring, fordi vi har brug for dine personoplysninger for at efterkomme en retlig forpligtelse eller i forbindelse med en retssag eller for at udøve retten til udtryks- og oplysningsfrihed. Du kan anmode om sletning i din Zietwing konto.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [_c("u", [_vm._v("37.4 Ret til begrænsning af behandling")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Du har ret til at bede os om at begrænse behandling af dine personoplysninger i følgende situationer:\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Hvis du bestrider nøjagtigheden af dine personoplysninger;\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Hvis behandlingen er ulovlig og du ikke ønsker at vi skal slette dine personoplysninger;\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Hvis vi ikke længere har brug for dine personoplysninger med henblik på behandling, men du har brug for data i forbindelse med et retskrav eller\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Du har gjort undsigelse mod vores behandling af dine personoplysninger afhængig af verifikation af om vores berettigede handelsinteresser er vigtigere end dine interesser, rettigheder og friheder, eller i forbindelse med en retssag.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Når du udøver denne ret, må vi kun opbevare dine personoplysninger. Vi må ikke viderebehandle dine data med mindre du giver dit samtykke, eller behandlingen er nødvendig I forbindelse med et retskrav eller for at beskytte en anden persons rettigheder eller for vægtige grunde i offentlighedens interesse. Vi vil informere dig inden behandlingsbegrænsningen ophæves.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [_c("u", [_vm._v("37.5 Ret til Data Portabilitet")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Du kan anmode os om at give dig de personoplysninger du har givet os i et struktureret almindelig brugt maskinlæsbart format.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    Denne ret forekommer kun hvor:\n  ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    · Vi behandler dine personoplysninger med dit samtykke eller det er nødvendigt at handle eller indgå kontraktmæssigt forhold med dig;\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    · Behandlingen udføres med automatiske midler.\n  ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    Du kan anmode om denne eksport i din Zietwing konto.\n  ")
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("38. Ansvarlig")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Du har til hver en tid ret til at gøre indsigelse mod behandlingen af dine personoplysninger når vi behandler dine personoplysninger i henhold til det retlige grundlag at vi tjener vores berettigede interesser.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    Denne anmodning kan foretages ved at sende mail til "),
        _c("a", { attrs: { href: "mailto:info@zietwing.com" } }, [
          _vm._v("info@zietwing.com")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Du kan udøve disse rettigheder i din Zietwing konto. Ved spørgsmål kan de sendes til info@zietwing.com\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Du har ret til at indgive klage hos datatilsynet med hensyn til Zietwing’s behandling af dine personoplysninger ved at tage kontakt til Datatilsynet, Borgergade 28, 5, 1300 København K. Tlf: 33 19 32 00 websted:\n    "
        ),
        _c("a", { attrs: { href: "https://www.datatilsynet.dk/kontakt" } }, [
          _vm._v("\n      https://www.datatilsynet.dk/kontakt\n    ")
        ]),
        _vm._v(" - eller ved at sende e-mail til : "),
        _c("a", { attrs: { href: "mailto:Dt@datatilsynet.dk" } }, [
          _vm._v("Dt@datatilsynet.dk")
        ])
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", [_vm._v("39. Ændringer i erklæringen")]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Hvis vi ændrer denne Erklæring, helt eller delvis, vil samtlige ændringer blive lagt op på din Zietwing konto, og hvis det er passende, meddelt dig per e-mail eller når du bruger Zietwing. Den nye Erklæring kan vise sig på skærmen og man kan kræve at du læser og accepterer den for at fortsætte med at bruge Zietwing.\n  "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45569a33", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45569a33","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/UserTerms.vue
// module id = aoJM
// module chunks = 1